import { Injectable } from '@angular/core';
import { CurrentUser } from 'se-resource-types/dist/lib/UserService';

import { UserService } from './user.service';
import { SeAuthService } from 'se-fe-auth-support';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private user: CurrentUser;
  private userAuthenticatedResult: Promise<CurrentUser>;

  constructor(
    private seAuthService: SeAuthService,
    private userService: UserService
  ) {
    this.userAuthenticatedResult = new Promise<CurrentUser>(
      (resolve, reject) => {
        this.userService.current.subscribe((user: CurrentUser) => {
          this.user = user;
          if (user) {
            resolve(user);
          }
        });
      }
    );
  }

  public async isCurrentUserAdmin(): Promise<boolean> {
    if (!this.user) {
      this.userService.findCurrent();
      await this.userAuthenticatedResult;
    }
    return await this.seAuthService.isAdmin();
  }

  public async isOrgAdmin(orgId: string): Promise<boolean> {
    if (!this.user) {
      this.userService.findCurrent();
      await this.userAuthenticatedResult;
    }
    const isOrgAdmin = !!this.user.role_assignments.find(
      (roleAssignment) =>
        roleAssignment.role === 'org_admin' &&
        roleAssignment.org_id?.toString() === orgId
    );
    const admin = await this.seAuthService.isAdmin();
    return Promise.resolve(isOrgAdmin || admin);
  }
}
